import React from 'react';

const duration = (props) => (
    <div className={`u-fontSize11 u-fontWeightRegular u-textColorNormal`}>
        {props.children}
    </div>
);

export default duration;


// WEBPACK FOOTER //
// ./src/components/Flight/UI/Mobile/Tuple/Duration/Duration.js